import './styles.css';
import { Game } from './game/Game';

const canvas = document.querySelector<HTMLCanvasElement>('#game-canvas');

if (!canvas) {
  throw new Error('Missing #game-canvas element.');
}
const gameCanvas = canvas;

let activeGame: Game | null = null;

async function bootstrap(): Promise<void> {
  activeGame = await Game.create(gameCanvas);
  activeGame.start();
}

void bootstrap();

if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    activeGame?.dispose();
    activeGame = null;
  });
}
